"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input-number/style/css");

var _inputNumber = _interopRequireDefault(require("antd/es/input-number"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireDefault(require("react"));

require("../activity.scss");

const {
  Item
} = _form.default;

const FillInTheBlankQuestion = props => {
  const {
    question,
    onTextChange,
    updateQuestion,
    disabled
  } = props;
  const {
    text,
    numBlanks,
    id,
    uuid
  } = question;

  const onNumBlanksChange = value => {
    if (value) {
      question.numBlanks = value;
      updateQuestion(question);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Item, {
    key: `fitb-question-text-${id || uuid}`,
    name: `fitb-question-text-${id || uuid}`,
    rules: [{
      required: true,
      message: 'Question must have text.'
    }],
    initialValue: text
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    spellCheck: true,
    disabled: disabled,
    placeholder: "Question text",
    onChange: onTextChange
  })), /*#__PURE__*/_react.default.createElement(Item, {
    key: `fitb-question-numOfBlanks-${id || uuid}`,
    name: `fitb-question-numOfBlanks-${id || uuid}`,
    rules: [{
      required: true,
      message: 'Fill in the blank questions must have number of blanks defined.'
    }],
    initialValue: numBlanks,
    label: "Number of Blanks:"
  }, /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
    disabled: disabled,
    min: 0,
    onChange: onNumBlanksChange
  })));
};

var _default = FillInTheBlankQuestion;
exports.default = _default;